import Layout from './Layout';
import useResponsive from '../../shared/utils/Responsive';
import TrainerSignUpForm from './TrainerSignUpForm';
import TrainerSmallScreen from './TrainerSmallScreen';

const TrainerUserSignUp = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <>
            {
                !isSmallScreen && (
                    <Layout text={"Trainer sign up to start guiding and inspiring learners."} firstSize={6} secondSize={6}>
                        <TrainerSignUpForm />
                    </Layout>
                )}
            {
                isSmallScreen && <TrainerSmallScreen tabPage={1} />
            }
        </>

    )
}

export default TrainerUserSignUp













